import React, { useContext, useState } from 'react';
import { Row, Col, Steps, Icon, Tag } from 'antd';
import Countdown from 'react-countdown';
import { useForm } from "react-hook-form";
import { AuthContext } from '../../../context/auth';
import FormLoading from '../../../components/common/loaders/formLoading';
import axios from 'axios';
import qs from 'qs';


export default function VerifyMobile(props) {
    const { user , login } = useContext(AuthContext)
    const [codeSended, setCodeSended] = useState(false);
    const [editingPhoneNumber, setEditingPhoneNumber] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const { register, formState: { errors }, handleSubmit } = useForm();


    const startVerifyMobile =async () => {
        setFormLoading(true);
        var config = {
            method: 'post',
            url: 'https://admin.bayatiexchange.com/api/mobile-verification/send',
            headers: {
                'Authorization': 'Bearer ' + user.jwt.toString()
            }
        };
        console.log('token is : ', user.jwt)
        await axios(config)
            .then(res => {
                console.log('res status', JSON.stringify(res));
                if (res.status === 200) {
                    setCodeSended(true);
                    setFormLoading(false);
                }
            })
            .catch(err => {

        });
    }

    const onSubmit = async formData => {
        var data = qs.stringify({
            'code': formData.verify_code
        });
        console.log(JSON.stringify(formData));
        setFormLoading(true);
        var config = {
            method: 'post',
            url: 'https://admin.bayatiexchange.com/api/mobile-verification/verify',
            headers: {
                'Authorization': 'Bearer ' + user.jwt.toString()
            },
            data: data
        };
        console.log('token is : ', user.jwt)
        await axios(config)
            .then(async res => {
                console.log('res status', JSON.stringify(res));
                if (res.status === 200) {
                    let newUserData = user;

                    newUserData.user.mobile_verified = true;
                    console.log(newUserData);

                    login(newUserData);

                    setFormLoading(false);
                    console.log('res status', JSON.stringify(res), 'email verified');

                    window.location.reload();
                }
            })
            .catch(err => {

        });
    }


    const onUpdateMobileNumSubmit = formData => {
        console.log(JSON.stringify(formData));
    }

    if (formLoading) {
        return (<FormLoading />)
    }
    else if (codeSended) {
        return (
            <div>
                <div className={"flex-rowReverse-center-center flex-wrap"} style={{ marginBottom: '20px' }}>
                    <p className={"normalText1"}>شماره موبایل : </p>
                    <h1 className={'phoneNumberVerify blackGradient1 textGradient'} style={{ margin: '0 4px 0 4px', fontSize: '28px' }}>{user.user.mobile_number}</h1>
                </div>

                <p className={"normalText1"} style={{ marginBottom: '15px', textAlign: 'center' }}>کد فعالسازی تا

                    <Countdown
                        date={Date.now() + 120000}
                        onComplete={() => { setCodeSended(false) }}
                        renderer={({ minutes, seconds }) => <b style={{ margin: '0 5px 0 5px' }}>{minutes + ':' + seconds}</b>}
                    />

                    دیگر برای شما ارسال می‌شود . </p>

                <form onSubmit={handleSubmit(onSubmit)}>


                    <div className="flex-column-center-center">
                        <div className="formItem" style={{ maxWidth: '200px', marginBottom: '15px' }}>
                            <input
                                className={"ant-input ant-input-lg"}
                                type="numeric"
                                {...register("verify_code", { required: true, maxLength: 6, minLength: 6, pattern: /^[0-9]*$/ })}
                                placeholder="کد فعالسازی"
                            />
                            <p className={"inputFormRrrorText"}>
                                {errors.verify_code && errors.verify_code.type === "pattern" && "از اعداد انگلیسی استفاده کنید"}
                                {errors.verify_code && errors.verify_code.type === "required" && "این فیلد ضروری است"}
                                {errors.verify_code && errors.verify_code.type === "minLength" && "کد شش رقمی می‌باشد"}
                                {errors.verify_code && errors.verify_code.type === "maxLength" && "کد شش رقمی می‌باشد"}
                            </p>
                        </div>
                    </div>
                    <div className={"formSubmitButton"}>
                        <div className={"normalButtonWrapper darkBtn"}>
                            <button type="submit" className={"normalButton loginButton"}>
                                <div className="normalButtonInner">
                                    <div>
                                        <Icon type={'check-circle'} />
                                    </div>
                                    <p>تأیید</p>
                                </div>
                            </button>
                        </div>

                    </div>
                </form>
            </div>
        )
    }
    else {
        if (!editingPhoneNumber) {
            return (
                <div>
                    <div className={"flex-rowReverse-center-center flex-wrap"} style={{ marginBottom: '20px' }}>
                        <p className={"normalText1"}>شماره موبایل : </p>
                        <h1 className={'phoneNumberVerify blackGradient1 textGradient'} style={{ margin: '0 4px 0 4px', fontSize: '28px' }}>{user.user.mobile_number}</h1>
                    </div>

                    <p className={"link-text"} style={{ marginBottom: '20px', textAlign: 'center' }} onClick={() => { setEditingPhoneNumber(true) }}>ویرایش شماره موبایل</p>
                    <div className={"normalButtonWrapper darkBtn largeBtn"}>
                        <a onClick={() => startVerifyMobile()} className={"normalButton"}>
                            <div className="normalButtonInner">
                                <div>
                                    <Icon type={'message'} style={{ fontSize: '25px', marginRight: '10px' }} />
                                </div>
                                <p style={{ fontSize: '18px' }}>ارسال کد فعالسازی</p>
                            </div>
                        </a>
                    </div>
                </div>
            )
        }
        else {
            return (
                <div>
                    <div className={"flex-rowReverse-center-center flex-wrap"} style={{ marginBottom: '20px' }}>
                        <p className={"normalText1"}>شماره موبایل فعلی : </p>
                        <h1 className={'phoneNumberVerify blackGradient1 textGradient'} style={{ margin: '0 4px 0 4px', fontSize: '28px' }}>{user.user.mobile_number}</h1>
                    </div>
                    <form onSubmit={handleSubmit(onUpdateMobileNumSubmit)}>
                        <div className={"flex-rowReverse-center-center flex-wrap"} style={{ marginBottom: '20px' }}>
                            <p className={"normalText1"}> شماره موبایل جدید : </p>
                            <div className="formItem" style={{ maxWidth: '600px' }}>
                                <input
                                    className={"ant-input ant-input-lg"}
                                    style={{ letterSpacing: '3px' }}
                                    type="numeric"
                                    {...register("new_mobile_number", { required: true, maxLength: 11, minLength: 11, pattern: /^[0-9]*$/ })}
                                    placeholder="09121234567"
                                />
                                <p className={"inputFormRrrorText"}>
                                    {errors.new_mobile_number && errors.new_mobile_number.type === "pattern" && "از اعداد انگلیسی استفاده کنید"}
                                    {errors.new_mobile_number && errors.new_mobile_number.type === "required" && "این فیلد ضروری است"}
                                    {errors.new_mobile_number && errors.new_mobile_number.type === "minLength" && "شماره موبایل ۱۱ رقمی می‌باشد"}
                                    {errors.new_mobile_number && errors.new_mobile_number.type === "maxLength" && "شماره موبایل ۱۱ رقمی می‌باشد"}
                                </p>
                            </div>
                        </div>
                        <p className={"link-text"} style={{ marginBottom: '20px', textAlign: 'center' }} onClick={() => { setEditingPhoneNumber(false) }}>لغو ویرایش</p>

                        <div className={"formSubmitButton"}>
                            <div className={"normalButtonWrapper darkBtn"}>
                                <button type="submit" className={"normalButton loginButton"}>
                                    <div className="normalButtonInner">
                                        <div>
                                            <Icon type={'mobile'} />
                                        </div>
                                        <p>به‌روزرسانی شماره موبایل</p>
                                    </div>
                                </button>
                            </div>

                        </div>
                    </form>
                </div>
            )
        }
    }
}
